var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0454E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3999 7.73751C10.3999 7.20588 10.8392 6.86118 11.2232 7.05419L11.299 7.1002L20.1011 13.3628L20.1709 13.4209C20.4979 13.7332 20.4748 14.3715 20.1011 14.6374L11.299 20.9C10.9245 21.1662 10.4618 20.8714 10.4055 20.3662L10.3999 20.2627V7.73751ZM11.1188 20.0067L19.561 14.0001L11.1188 7.99289V20.0067Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.4b25ecd61c6cdc3814679ec46a81b748.svg";
export { ForwardRef as ReactComponent };